import React from "react";
import "./tagline.scss";
const TagLine = () => {
  return (
    <section className="tagline">
      <div className="tagline__content">
        <h5>
          <span>ALL CAKES ARE TAILORED TO YOUR TASTE AND STYLE</span>
        </h5>
      </div>
    </section>
  );
};

export default TagLine;
